import React from 'react';

import {
	SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE,
	LazySpaceDetailsPage,
} from '@confluence/space-settings';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceSettingsDetailsRoute: {
	({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): React.JSX.Element;
	NAVIGATION_PARAMS({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): {
		Screen: {
			screenEvent: {
				name: string;
			};
			pageState: {
				spaceKey: any;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): React.JSX.Element => {
	return (
		<SpaceBase>
			<LazySpaceDetailsPage spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceSettingsDetailsRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): {
	Screen: {
		screenEvent: {
			name: string;
		};
		pageState: {
			spaceKey: any;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE },
		pageState: { spaceKey },
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
	},
});
